module.exports = __webpack_public_path__ + "img/Foley_Field-RN-t-26764-009.c31590d8.jpg";